import React, { useEffect, useMemo, useRef, useState } from 'react'
import './KitModeloBusca.css'

function chaveItem(item) {
  return `${String(item?.marca || '').trim().toLowerCase()}|${String(item?.modelo || '').trim().toLowerCase()}`
}

export default function KitModeloBusca({
  itens = [],
  placeholder = 'Pesquisar marca ou modelo...',
  unidadePotencia = '',
  inputId,
  name,
  value = '',
  label,
  onSelect,
  buscarRemoto,
  nomeItem = 'modelo',
  podeCadastrar = false,
  onCadastrar
}) {
  const [aberto, setAberto] = useState(false)
  const [termo, setTermo] = useState(value || '')
  const [remotos, setRemotos] = useState([])
  const [buscando, setBuscando] = useState(false)
  const wrapRef = useRef(null)
  const buscaIdRef = useRef(0)

  useEffect(() => {
    if (!aberto) setTermo(value || '')
  }, [value, aberto])

  const termoBusca = aberto ? termo : (value || '')

  const locais = useMemo(() => {
    const q = String(termoBusca || '').trim().toLowerCase()
    const lista = Array.isArray(itens) ? itens : []
    if (!q) return lista.slice(0, 40)
    return lista
      .filter((item) => {
        const marca = String(item.marca || '').toLowerCase()
        const modelo = String(item.modelo || '').toLowerCase()
        const potencia = String(item.potencia ?? '').toLowerCase()
        return marca.includes(q) || modelo.includes(q) || potencia.includes(q) || `${marca} ${modelo}`.includes(q)
      })
      .slice(0, 40)
  }, [itens, termoBusca])

  const filtrados = useMemo(() => {
    const vistos = new Set()
    const saida = []
    for (const item of [...locais, ...remotos]) {
      const chave = chaveItem(item)
      if (!chave || chave === '|') continue
      if (vistos.has(chave)) continue
      vistos.add(chave)
      saida.push(item)
      if (saida.length >= 40) break
    }
    return saida
  }, [locais, remotos])

  useEffect(() => {
    if (!aberto || typeof buscarRemoto !== 'function') {
      setBuscando(false)
      return
    }
    const id = ++buscaIdRef.current
    const t = setTimeout(async () => {
      setBuscando(true)
      try {
        const lista = await buscarRemoto(String(termo || '').trim())
        if (buscaIdRef.current === id) setRemotos(Array.isArray(lista) ? lista : [])
      } catch {
        if (buscaIdRef.current === id) setRemotos([])
      } finally {
        if (buscaIdRef.current === id) setBuscando(false)
      }
    }, 400)
    return () => clearTimeout(t)
  }, [aberto, termo, buscarRemoto])

  useEffect(() => {
    const fechar = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setAberto(false)
    }
    document.addEventListener('mousedown', fechar)
    return () => document.removeEventListener('mousedown', fechar)
  }, [])

  const solicitarCadastro = () => {
    setAberto(false)
    onCadastrar?.(String(termo || '').trim())
  }

  return (
    <div className="kit-modelo-busca" ref={wrapRef}>
      {label && (
        <label className="kit-modelo-busca-label" htmlFor={inputId}>{label}</label>
      )}
      <div className="kit-modelo-busca-campo">
        <i className="bi bi-search" aria-hidden />
        <input
          id={inputId}
          name={name}
          type="search"
          className="kit-modelo-busca-input"
          placeholder={placeholder}
          value={aberto ? termo : (value || '')}
          onChange={(e) => {
            setTermo(e.target.value)
            setAberto(true)
          }}
          onFocus={() => {
            setTermo(value || termo || '')
            setAberto(true)
          }}
          autoComplete="off"
        />
      </div>
      {aberto && (
        <div className="kit-modelo-busca-resultados" role="listbox">
          {buscando && (
            <div className="kit-modelo-busca-status">Buscando modelos…</div>
          )}
          {filtrados.length === 0 && !buscando ? (
            <div className="kit-modelo-busca-vazio">
              <p>Esta marca de {nomeItem} não está na lista.</p>
              {podeCadastrar && typeof onCadastrar === 'function' ? (
                <button
                  type="button"
                  className="kit-modelo-busca-cadastrar"
                  onClick={solicitarCadastro}
                >
                  Cadastrar marca de {nomeItem}
                </button>
              ) : (
                <span>Solicite o cadastro a um administrador.</span>
              )}
            </div>
          ) : (
            filtrados.map((item) => (
              <button
                key={item.id || chaveItem(item)}
                type="button"
                className="kit-modelo-busca-item"
                onClick={() => {
                  onSelect(item)
                  setAberto(false)
                }}
              >
                <span className="kit-modelo-busca-item-texto">
                  <strong>{item.marca}</strong>
                  <span>{item.modelo}</span>
                </span>
                {item.potencia != null && item.potencia !== '' && (
                  <em>{item.potencia} {unidadePotencia}</em>
                )}
              </button>
            ))
          )}
          {podeCadastrar && typeof onCadastrar === 'function' && filtrados.length > 0 && !buscando && (
            <div className="kit-modelo-busca-vazio kit-modelo-busca-rodape">
              <p>Não encontrou a marca?</p>
              <button
                type="button"
                className="kit-modelo-busca-cadastrar"
                onClick={solicitarCadastro}
              >
                Cadastrar marca de {nomeItem}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
